import { DEFAULT_SHIPPING_METHOD_ID } from "./defaults";
import type { ShippingMethod, ShippingMethodId, ShippingSettings } from "./types";

export function getEnabledShippingMethods(settings: ShippingSettings): ShippingMethod[] {
  return settings.shippingMethods.filter((method) => method.enabled);
}

export function resolveShippingMethod(
  settings: ShippingSettings,
  methodId: ShippingMethodId | string | undefined,
): ShippingMethod | null {
  const enabled = getEnabledShippingMethods(settings);
  const id = methodId === "express" ? "express" : methodId === "standard" ? "standard" : null;

  if (id) {
    const match = enabled.find((m) => m.methodId === id);
    if (match) return match;
  }

  return enabled.find((m) => m.methodId === DEFAULT_SHIPPING_METHOD_ID) ?? enabled[0] ?? null;
}

export function isValidShippingMethodId(
  settings: ShippingSettings,
  methodId: string | undefined,
): methodId is ShippingMethodId {
  if (methodId !== "standard" && methodId !== "express") return false;
  return getEnabledShippingMethods(settings).some((method) => method.methodId === methodId);
}

export function computeShippingFee(
  settings: ShippingSettings,
  methodId: ShippingMethodId | string | undefined,
  exchangeRate: number,
): number {
  const method = resolveShippingMethod(settings, methodId);
  if (!method) return 0;
  return Number((method.fee * exchangeRate).toFixed(2));
}

export function computeShippingFeeStripeSmallestUnits(
  settings: ShippingSettings,
  methodId: ShippingMethodId | string | undefined,
  exchangeRate: number,
): number {
  return Math.round(computeShippingFee(settings, methodId, exchangeRate) * 100);
}
